<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="text-indent: 00em; padding-top: 200px; text-align: center;"><strong><em>“When you see your likeness, you rejoice. But when you see your images which came into being before you and which neither die nor become manifest, how much you will have to bear.”</em></strong></p><br/>
<p style="text-indent: 00em; text-align: right;"><strong><em>— Attributed to Jesus Christ</em></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?761c4258